/* eslint-disable functional/immutable-data */

import { useCallback, useEffect, useRef, useState } from 'react';

export const useStepperTimeout = (callback?: () => void): UseStepperTimeout => {
  const [activeStepperId, setActiveStepperId] = useState<string | null>(null);
  const timerId = useRef<ReturnType<typeof setTimeout>>(undefined);

  const clearStepperTimeout = useCallback(() => {
    if (timerId.current) {
      clearTimeout(timerId.current);

      timerId.current = undefined;
    }
  }, []);

  const resetStepperTimeout = useCallback(() => {
    clearStepperTimeout();

    const id = setTimeout(() => {
      setActiveStepperId(null);
      callback?.();
    }, 1200);

    timerId.current = id;
  }, [callback, clearStepperTimeout]);

  useEffect(() => {
    return clearStepperTimeout;
  }, [clearStepperTimeout]);

  return {
    activeStepperId,
    resetStepperTimeout,
    clearStepperTimeout,
    setActiveStepperId,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UseStepperTimeout = {
  activeStepperId: string | null;
  resetStepperTimeout: () => void;
  clearStepperTimeout: () => void;
  setActiveStepperId: (stepperId: string | null) => void;
};
